import React from "react";

const Loading = ({ customClass }) => (
    <div className={`spinner ${customClass}`}>
        <img className="adventurelearn_loadingSpinner" src='./loading.svg' alt="Loading" />
    </div>
);

export default Loading;